import React, { useState, useEffect } from "react";
import {
  Flex,
  Text,
  Box,
  SimpleGrid,
  useBreakpointValue,
} from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";
import Info from "../components/Info";
import {
  RiArrowRightDoubleFill,
  RiGitClosePullRequestLine,
  RiQuillPenLine,
  RiTeamLine,
} from "react-icons/ri";

const images = [
  "screenshots/stacja.png",
  "screenshots/gielda-ui.png",
  "screenshots/gielda.png",
  "screenshots/salon.png",
  "screenshots/stacja.png",
  "screenshots/tuner.png",
  "screenshots/zlomowisko.png",
];

const preloadImages = (imageArray) => {
  imageArray.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
};

const Component = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const directionRight = useBreakpointValue({
    base: "right",
    sm: "right",
    md: "right",
    xl: "right",
  });
  const directionLeft = useBreakpointValue({
    base: "right",
    sm: "right",
    md: "right",
    lg: "left",
    xl: "right",
  });

  useEffect(() => {
    preloadImages(images);
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Flex direction={"column"} alignItems={"center"} gap={"122px"}>
      <Flex
        gap={"34px"}
        direction={"column"}
        alignItems={"center"}
        width={{ base: "100%", md: "90%" }}
      >
        <Text fontSize={"42px"} align={"center"} lineHeight={"135%"}>
          Dowiedz się więcej o projekcie
          <Text fontWeight={"600"}>socialproject.pl</Text>
        </Text>
        <Text
          fontSize={"18px"}
          align={"center"}
          lineHeight={"125%"}
          color={"#B6B6B6"}
        >
          Poznaj unikalne możliwości naszego projektu – odkryj{" "}
          <Text as={"span"} color={"#fff"}>
            innowacyjne systemy
          </Text>
          {", "}
          <Text as={"span"} color={"#fff"}>
            angażujące wydarzenia
          </Text>
          {" i "}
          <Text as={"span"} color={"#fff"}>
            społeczność
          </Text>
          {", która tworzy "}
          <Text as={"span"} color={"#fff"}>
            niezapomniane historie
          </Text>
          .
        </Text>
      </Flex>
      <Flex
        direction={{ base: "column", xl: "row" }}
        gap={{base: "88px", xl: "2px"}}
        width={"100%"}
        justifyContent={"center"}
      >
        <SimpleGrid columns={{ sm: 1, md: 1, lg: 2, xl: 1 }} gap={"24px"}>
          <Info
            title={"Doświadczony zespół"}
            description={
              "Tworzymy zespół ekspertów z wieloletnim doświadczeniem na MTA."
            }
            icon={<RiTeamLine size={24} color={"#C8C8C8"} />}
            rotation={directionRight === "right" ? "270deg" : "90deg"}
            direction={directionRight}
          />
          <Info
            title={"Innowacyjne rozwiązania"}
            description={
              "Wprowadzamy rozwiązania, które wyznaczają nowe standardy w branży."
            }
            icon={<RiGitClosePullRequestLine size={24} color={"#C8C8C8"} />}
            rotation={directionLeft === "right" ? "270deg" : "90deg"}
            direction={directionLeft}
          />
          <Info
            title={"Wizja przyszłości"}
            description={"Zawsze o krok przed konkurencją - to nasz cel!"}
            icon={<RiArrowRightDoubleFill size={24} color={"#C8C8C8"} />}
            rotation={directionRight === "right" ? "270deg" : "90deg"}
            direction={directionRight}
          />
          <Info
            title={"Zaangażuj się"}
            description={
              "Razem tworzymy przyszłość, a to Twoja opinia kształtuje nasz rozwój!"
            }
            icon={<RiQuillPenLine size={24} color={"#C8C8C8"} />}
            rotation={directionLeft === "right" ? "270deg" : "90deg"}
            direction={directionLeft}
          />
        </SimpleGrid>
        <Box
          height={{ base: "500px", xl: "auto" }}
          width={{ base: "100%", xl: "45%" }}
          borderRadius={"23px"}
          border={"1px solid rgba(255, 255, 255, 0.28)"}
          overflow={"hidden"}
          position={"relative"}
        >
          <AnimatePresence>
            <motion.img
              key={currentImageIndex}
              src={images[currentImageIndex]}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1 }}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </AnimatePresence>
        </Box>
      </Flex>
    </Flex>
  );
};

export default Component;
